import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import theme from '../../theme';

class Annotation extends React.Component {
    static propTypes = {
        color: PropTypes.oneOf(['cyan', 'green', 'red', 'yellow']).isRequired,
        cx: PropTypes.number.isRequired,
        cy: PropTypes.number.isRequired,
        r: PropTypes.number.isRequired,
        type: PropTypes.oneOf(['note', 'question', 'answered-question']),
    };

    getTransform = (maxWidth, maxHeight, naturalRadius) => {
        let cx = maxWidth / 2;
        let cy = maxHeight / 2;
        // naturalRadius needs to be calculated for the paper, but is known for
        // the circles.
        if (!naturalRadius) {
            naturalRadius = Math.sqrt(cx * cx + cy * cy);
        }
        const scale = this.props.r / naturalRadius;

        // In order to to make this.props.cx the center, these have to be
        // scaled before being subtraced from the props.
        cx = cx * scale;
        cy = cy * scale;

        let transform = '';
        transform +=
            'translate(' +
            (this.props.cx - cx) +
            ', ' +
            (this.props.cy - cy) +
            ') ';
        transform += 'scale(' + scale + ')';
        return transform;
    };

    renderAnswered = () => {
        const checkShape = (function() {
            const instructions = [];
            instructions.push(['M', 25, 60]);
            instructions.push(['L', 50, 75]);
            instructions.push(['L', 75, 40]);
            return instructions
                .map(function(i) {
                    return i.join(' ');
                })
                .join(' ');
        })();

        return (
            <StyledAnnotation transform={this.getTransform(100, 100, 50)}>
                <circle cx={50} cy={50} r={50} className={this.props.color} />
                <path d={checkShape} className={this.props.color + ' check'} />
            </StyledAnnotation>
        );
    };

    renderNote = () => {
        return (
            <StyledAnnotation transform={this.getTransform(85, 110)}>
                <circle cx={50} cy={50} r={50} className={this.props.color} />
            </StyledAnnotation>
        );
    };

    renderQuestion = () => {
        return (
            <StyledAnnotation transform={this.getTransform(100, 100, 50)}>
                <circle cx={50} cy={50} r={50} className={this.props.color} />
                <text
                    x={50}
                    y={80}
                    fontSize={80}
                    textAnchor="middle"
                    className={this.props.color}
                >
                    Q
                </text>
            </StyledAnnotation>
        );
    };

    render() {
        switch (this.props.type) {
            case 'note':
                return this.renderNote();
            case 'question':
                return this.renderQuestion();
            case 'answered-question':
                return this.renderAnswered();
        }
    }
}

const StyledAnnotation = styled.g`
    path.check {
        fill: none;
        stroke: black;
        stroke-width: 10;
        stroke-linecap: square;

        &.cyan,
        &.red {
            stroke: white;
        }
    }

    circle,
    path {
        ${Object.keys(theme.colors.highlights).map(color => {
            return `&.${color}:not(.check) {
                    fill: ${theme.colors.highlights[color].default};
                    stroke: ${theme.colors.highlights[color].dark};
                    stroke-width: 7;
                }`;
        })};
    }

    text {
        &.cyan,
        &.red {
            fill: white;
        }
    }
`;

export default Annotation;



// WEBPACK FOOTER //
// ./src/components/text_viewer/highlight/annotation.jsx